import { Route } from '@angular/router';
import DefaultRoutes from '@app/src/app/modules/default/routes/public/default.routes';
import NotFoundRoutes from '@app/src/app/modules/not-found/routes/not-found.routes';
import { environment } from '@app/src/environments/environment';

export default {
  path: '',
  loadComponent: () =>
    import('@app/src/app/components/front/front').then((m) => m.Front),
  data: {
    meta: {
      enableRobots: environment.production,
    },
  },
  children: [DefaultRoutes, NotFoundRoutes],
} as Route;
